import t from "clipper-lib";
import { pathToPoly as P } from "./internal/index.js";
import { polyToPath as n } from "./internal/index2.js";
const l = 1e5;
function S(r, a) {
  const o = new t.Clipper(), i = r[0][1], s = n(r), c = a.map((p) => n(p));
  t.JS.ScaleUpPath(s, l), t.JS.ScaleUpPaths(c, l), o.AddPath(s, t.PolyType.ptSubject, !0), o.AddPaths(c, t.PolyType.ptClip, !0);
  const e = [];
  return o.Execute(t.ClipType.ctIntersection, e, t.PolyFillType.pftNonZero, t.PolyFillType.pftNonZero), t.JS.ScaleDownPaths(e, l), e.map((p) => P(p, i));
}
export {
  S as intersectPolygons
};
//# sourceMappingURL=index4.js.map
